module.exports = __webpack_public_path__ + "img/smsx.f9c37870.png";